import { render, staticRenderFns } from "./DonePage.vue?vue&type=template&id=6564f6f5&scoped=true"
import script from "./DonePage.vue?vue&type=script&lang=js"
export * from "./DonePage.vue?vue&type=script&lang=js"
import style0 from "./DonePage.vue?vue&type=style&index=0&id=6564f6f5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6564f6f5",
  null
  
)

export default component.exports